/**
 * Placeholder brand/contact constants (09-landing-page.md §9 "Assumptions & open items" #1/#3) —
 * real logo, legal name, address and phone/WhatsApp numbers are pending the client; swap the
 * values here only, nothing structural changes. Consumed by the footer, JSON-LD structured data,
 * the success panel's WhatsApp quick-contact link, and the 429/CAPTCHA-failure fallback copy.
 */
export const BRAND = {
  // Brand name is the Latin "Future Academy" in every locale, including Arabic (2026-07 request):
  // the academy's identity renders identically on ar and en pages.
  nameAr: "Future Academy",
  nameEn: "Future Academy",
  /** Display phone (Western Arabic numerals per design §8 numeral convention). */
  phoneDisplay: "01000000000",
  /** E.164, used for tel:/WhatsApp links. */
  phoneE164: "+201000000000",
  whatsappNumber: "201000000000",
  email: "admissions@futureacademy.example",
  addressAr: "شارع التعليم، القاهرة الجديدة، القاهرة",
  addressEn: "Education St., New Cairo, Cairo",
  facebookUrl: "https://www.facebook.com/futureacademy",
  instagramUrl: "https://www.instagram.com/futureacademy",
  ogImage: "https://future-academy-eg.com/og-image.jpg",
  logoUrl: "https://future-academy-eg.com/logo.png",
} as const;

export function whatsappLink(message: string): string {
  return `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(message)}`;
}
